// src/app/shared/user-data.service.ts
import { Injectable } from '@angular/core';
import { IThreatAssessmentTeam } from '../../models/contact';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private buildingId: string | null = null;
  private regionId : string | null = null;
  private contactList: IThreatAssessmentTeam[] = [];
  private contact: IThreatAssessmentTeam | null = null; 

  setBuildingId(buildingId: string): void {
    this.buildingId = buildingId;
  }

  setRegionId(regionId: string): void {
    this.regionId = regionId;
  }

  setAssessUsersList(contactList: IThreatAssessmentTeam[]): void {
    this.contactList = contactList;
  }

  setCurrentUser(contact: IThreatAssessmentTeam): void {
    this.contact = contact;
  }

  getBuildingId(): string | null {
    return this.buildingId;
  }
  
  getRegionId(): string | null {
    return this.regionId;
  }

  getAssessUsersList(): IThreatAssessmentTeam[] {
    return this.contactList;
  }

  getCurrentUser(): IThreatAssessmentTeam | null {
    return this.contact;
  }
}
